import React, { useRef } from "react";
import PreOrderBookInfo from "../../../BookModule.module.css";
import DatePicker_book from "../../../DatePicker_book";
import moment from "moment";

export default function PreOrderBook(props) {
  const txtAdMDob = useRef(null);
  const handleYearChange = (year, dname) => {
    if (dname === "book_expected_date") {
    }
  };

  const handleMonthChange = (month, dname) => {
    if (dname === "book_expected_date") {
    }
  };

  return (
    <div className="row mt-3">
      <div className="col-xl-12 col-lg-12 col-md-12 col-12">
        <fieldset className={PreOrderBookInfo.preorderContainer}>
          <legend className="w-auto mb-0">
            Pre-Order Book {props.record.id > 1 ? "-" : "1"}
            {props.record.id > 1 ? props.record.id : ""}
          </legend>
          <div className="row mx-0">
            <div class="col-xl-6 col-lg-6 mb-3 ps-0 col-md-6 col-12  d-flex flex-column">
              <label
                for={"book_name"}
                class="form-label confirm_value disabled_btn "
              >
                Book Name
              </label>
              <input
                className={`${PreOrderBookInfo.textInputBox} disabled_btn`}
                type="text"
                ref={props.preorderBookNameRef}
                id={"book_name"}
                disabled
                name={"book_name"}
                placeholder="Book Name"
                onChange={(e) =>
                  props.preOrderChange(
                    e,
                    props.record.book_id,
                    props.record.id,
                    props.index
                  )
                }
                value={props.record.book_title}
              />
              {props.bookErrors[`book_name_error_${props.index}`] && (
                <small className={`error_message mt-2`}>
                  {props.bookErrors[`book_name_error_${props.index}`]}
                </small>
              )}
            </div>
            <div class="col-xl-6 col-lg-6 mb-3 ps-0 col-md-6 col-12 d-flex flex-column">
              <label
                for="book_pre_order_count"
                class="form-label confirm_value "
              >
                Pre-Order Count
              </label>
              <input
                className={`${PreOrderBookInfo.textInputBox}`}
                type="number"
                id="book_pre_order_count"
                name="book_pre_order_count"
                ref={props.preorderpcountRef}
                placeholder="Enter pre order count"
                onChange={(e) =>
                  props.preOrderChange(
                    e,
                    props.record.book_id,
                    props.record.id,
                    props.index
                  )
                }
                value={props.record.book_pre_order_count}
              />

              {props.bookErrors[
                `book_pre_order_count_error_${props.index}`
              ] && (
                <small className={`error_message mt-2`}>
                  {
                    props.bookErrors[
                      `book_pre_order_count_error_${props.index}`
                    ]
                  }
                </small>
              )}
            </div>
            <div class="col-xl-6 col-lg-6  ps-0 col-md-6 col-12 d-flex flex-column">
              <label for="book_expected_date" class="form-label confirm_value ">
                Expected by Date
              </label>

              <DatePicker_book
                handleYearChange={handleYearChange}
                txtAdMDob={props.preorderexpectedDateRef}
                handleMonthChange={handleMonthChange}
                class={`${PreOrderBookInfo.textInputBox}`}
                name={"book_expected_date"}
                indexS={props.index}
                errors_date={
                  props.bookErrors[`book_expected_date_error_${props.index}`]
                }
                bookId={props.record.book_id}
                fieldsId={props.record.id}
                fieldInput={props.record.book_expected_date}
                IconInput={PreOrderBookInfo.DateIconInput}
                handleIdChange={props.handlePreOrderChangeDate}
                minDate={moment().add(1, "days").toDate()} // Start from tomorrow
              />
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  );
}
